import { Drawer } from 'antd'

import { drawerAndModalWidth } from '../../../../../util/guideline'
import { CreateIssuerCompliance } from './CreateIssuerComplianceRule'

interface CreateIssuerComplianceDrawerProps {
  domain: string
  groupId: number
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const CreateIssuerComplianceRuleDrawer = ({
  domain,
  groupId,
  isVisible,
  onClose,
  onSuccess,
}: CreateIssuerComplianceDrawerProps) => (
  <Drawer
    title="Create Issuer Compliance Rule"
    placement="right"
    open={isVisible}
    onClose={onClose}
    width={drawerAndModalWidth}
    destroyOnClose
  >
    <CreateIssuerCompliance domain={domain} groupId={groupId} onSuccess={onSuccess} />
  </Drawer>
)
